import React from 'react';
import { translation } from "../../../utils";
import { VennDiagram } from "./vennDiagram";

export const AboutMe = () => {
  return (
    <div className='about-section' style={{ width: '100%' }}>
      <div>
        <div className="about-profile profile-icon background-image" />
        <p className="body">{translation.about}</p>
      </div>
      <VennDiagram />
    </div>
  )
}
